




































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { Location } from "vue-router";
import AutomatedInvestmentFundingV2 from "@/shared/components/investments/drivewealth/sweep/AutomatedInvestmentFundingV2.vue";
import RiskDisclaimer from "@/shared/components/investments/drivewealth/RiskDisclaimer.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import * as RouteNames from "@/employee/route-names";
import * as SharedRoutes from "@/shared/route-names";
import {
  DrivewealthWizardStep
} from "@/shared/types";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useInvestmentDailyBalanceStore } from "@/shared/store/investmentDailyBalance";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";

@Component({
  components: {
    GenericLoadingSpinner,
    RiskDisclaimer,
    AutomatedInvestmentFundingV2,
  }
})
export default class SweepPageV2 extends Vue {

  drivewealthStore = useDrivewealthStore();
  investmentDailyBalanceStore = useInvestmentDailyBalanceStore();
  drivewealthWizardStore = useDrivewealthWizardStore();

  @Prop({ required: true })
  isPreenrollment: boolean;

  @Prop({ required: false, default: false })
  isUserOnboarding: boolean;

  @Prop({ required: true })
  isWizard: boolean;

  @Prop({ required: false })
  accountId: number;

  warnBeforeRouteLeave = false;
  warnBeforeRouteLeaveMessage = "";

  mounted () {
    this.drivewealthStore.loadAccountSummariesV2({});
    this.investmentDailyBalanceStore.loadHsaBalanceAndThreshold({});
    this.drivewealthWizardStore.loadExistingPreenrollment({});
  }

  get isLoaded (): boolean {
    return this.investmentDailyBalanceStore.isHsaBalanceAndThresholdLoaded
        && this.drivewealthWizardStore.isEnrollmentLoaded;
  }

  get redirectLocation (): Location {
    if (this.accountId) {
      return {
        name: SharedRoutes.DrivewealthInvestmentAccountV2,
        params: { accountId: `${this.accountId}`}
      };
    }
    return {name: RouteNames.InvestmentAccountInfo};
  }

  get investmentLanding (): string {
    return RouteNames.InvestmentAccountInfo;
  }

  get isStandalone (): boolean {
    return !this.isPreenrollment && !this.isUserOnboarding;
  }

  beforeRouteLeave (to, from, next): void {
    if (this.warnBeforeRouteLeave) {
      const userWantsToLeave = window.confirm(this.warnBeforeRouteLeaveMessage);
      if (userWantsToLeave) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }

  onNavigationGuardChange (data: { confirmNavigation: boolean; message: string }): void {
    this.warnBeforeRouteLeave = data.confirmNavigation;
    this.warnBeforeRouteLeaveMessage = data.message;
  }

  showThisSweep (): boolean {
    return this.drivewealthStore.hasAnAccount || this.drivewealthWizardStore.isPreenrolled;
  }

  onComplete (): void {
    if (this.isUserOnboarding) {
      this.drivewealthWizardStore.setWizardStepComplete(DrivewealthWizardStep.AutomatedFunding);
      return;
    } // routing from here handled by the wizard.

    this.$router.push(this.redirectLocation);
  }
}
